import React, { useEffect } from 'react';
import { Row, Col, Container } from 'reactstrap';
import { useAuth0 } from '@auth0/auth0-react';
import { Freshchat } from 'reactjs-freshchat';
import 'reactjs-freshchat/dist/index.css';

const Footer = () => {
	const { isAuthenticated, user } = useAuth0();
	let User = user;
	useEffect(() => {
		//
	}, [User]);
	useEffect(() => {
		//
	}, [isAuthenticated]);

	return (
		<React.Fragment>
			<footer className='footer'>
				{isAuthenticated ? (
					<Freshchat
						host={'https://ofca-help.freshchat.com'}
						token={'59db8791-ba8c-45ee-9487-d81c30d7ed8d'}
						externalId={User?.nickname}
						firstName={User?.fullname}
						email={User?.email}
					/>
				) : null}
				<Container fluid>
					<Row>
						<Col
							xs={6}
							className='pl-5'
						>
							<span className='ml-4'>
								{new Date().getFullYear()} &#169; Triple-Innovations Ltd
							</span>
						</Col>
						<Col xs={6}>
							<div className='text-sm-right d-none d-sm-block'>
								Made with <i className='mdi mdi-heart text-danger'></i> by OFCA team
							</div>
						</Col>
					</Row>
				</Container>
			</footer>
		</React.Fragment>
	);
};

export default Footer;
